import React from 'react';

const STATUS_MAP = {
    draft:     { label: 'Draft',     className: 'bg-secondary' },
    ready:     { label: 'Ready',     className: 'bg-primary' },
    sending:   { label: 'Sending',   className: 'bg-warning text-dark' },
    sent:      { label: 'Sent',      className: 'bg-success' },
    failed:    { label: 'Failed',    className: 'bg-danger' },
    cancelled: { label: 'Cancelled', className: 'bg-secondary' },
};

const TYPE_MAP = {
    operational: { label: 'Operational', className: 'bg-info text-dark' },
    marketing:   { label: 'Marketing',   className: 'bg-purple text-white' },
};

export function CampaignStatusBadge({ status }) {
    const cfg = STATUS_MAP[status] || { label: status, className: 'bg-secondary' };
    return <span className={`badge ${cfg.className}`}>{cfg.label}</span>;
}

export function CampaignTypeBadge({ type }) {
    const cfg = TYPE_MAP[type] || { label: type, className: 'bg-secondary' };
    return (
        <span className={`badge ${cfg.className}`} style={type === 'marketing' ? { background: '#7c3aed' } : {}}>
            {cfg.label}
        </span>
    );
}
